import { Address } from '@weave/schema-gen-ts/dist/schemas/brand-settings/v1/settings.pb';
import { formatLocationAddress } from './format-location-address';

/**
 * formatLocationAddressLink converts an address into a Google Maps place URL.
 *
 * @param address - location address object to be formatted into a map link
 * @returns Google Maps URL, or an empty string when address is unavailable
 */
export const formatLocationAddressLink = (address?: Address) => {
  const query = formatLocationAddress(address).trim();
  if (!query) return '';

  // Use + for spaces while still encoding reserved characters.
  const normalizedAddress = query.split(/\s+/).join(' ');
  const encodedAddress = encodeURIComponent(normalizedAddress).replace(/%20/g, '+');

  return `https://www.google.com/maps/place/${encodedAddress}`;
};
